import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonStateDirective } from './directives/button-state-directive'
import { NumberOnlyDirective } from './directives/number.directive'
import { ButtonComponent } from './button/button.component'
import { SelectComponent } from 'app/shared/select/select.component'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CalendarModule } from 'primeng/components/calendar/calendar'
import { CheckboxComponent } from 'app/shared/checkbox/checkbox.component'
import { GridComponent, GridHeader, GridBody } from 'app/shared/grid/grid.component'
import { StickyDirective } from 'app/shared/directives/sticky-directive'
import { ValidationSummaryComponent } from 'app/shared/validation-summary/validation-summary.component'
import { DatepickerComponent } from 'app/shared/datepicker/datepicker.component'
import { PopupComponent } from 'app/shared/popup/popup.component'
import { SpinnerDirective } from 'app/shared/directives/spinner-directive'
import { ValidateValidDirective } from 'app/shared/directives/validate-valid-directive'
import { DisableControlDirective } from 'app/shared/directives/disable-control.directive'
import { TextMaskModule } from 'angular2-text-mask'
import { ContentfulGenericPageComponent } from '../contentful/contentful-generic-page/contentful-generic-page.component'
import { ContentfulContentRowComponent } from '../contentful/contentful-content-row/contentful-content-row.component'
import { ContentfulInfoBlockComponent } from '../contentful/contentful-info-block/contentful-info-block.component'
import { MarkdownModule } from 'ngx-markdown';
import { CabinGroupCache } from 'app/cabins/cabin-group/cabin-group.cache';
import { StuckDirective } from './directives/stuck.directive';
import { Datepicker2Component } from './datepicker2/datepicker2.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { BannerComponent } from './banner/banner.component';
import { ExploreBannerComponent } from './explore-banner/explore-banner.component'

@NgModule({
    imports: [
        CommonModule, RouterModule, BrowserAnimationsModule, CalendarModule, FormsModule, TextMaskModule,
        MarkdownModule.forRoot(),
    ],
    declarations: [
        ButtonStateDirective,
        NumberOnlyDirective,
        ButtonComponent,
        SelectComponent,
        CheckboxComponent,
        GridComponent,
        GridHeader,
        GridBody,
        ValidationSummaryComponent,
        DatepickerComponent,
        Datepicker2Component,
        DateRangePickerComponent,
        PopupComponent,
        SpinnerDirective,
        ValidateValidDirective,
        StickyDirective,
        DisableControlDirective,
        StuckDirective,
        ContentfulGenericPageComponent,
        ContentfulContentRowComponent,
        ContentfulInfoBlockComponent,
        BannerComponent,
        ExploreBannerComponent
    ],
    exports: [
        ButtonStateDirective,
        NumberOnlyDirective,
        ButtonComponent,
        SelectComponent,
        CheckboxComponent,
        GridComponent,
        GridHeader,
        GridBody,
        ValidationSummaryComponent,
        DatepickerComponent,
        Datepicker2Component,
        DateRangePickerComponent,
        PopupComponent,
        SpinnerDirective,
        ValidateValidDirective,
        StickyDirective,
        StuckDirective,
        DisableControlDirective,
        TextMaskModule,
        ContentfulGenericPageComponent,
        ContentfulContentRowComponent,
        ContentfulInfoBlockComponent,
        BannerComponent,
        ExploreBannerComponent
    ],
    providers: [CabinGroupCache],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UIModule {
}

